import { render, staticRenderFns } from "./CoTwoFilmVehicleForm.vue?vue&type=template&id=74a7508b&scoped=true&"
import script from "./CoTwoFilmVehicleForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoFilmVehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7508b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a7508b')) {
      api.createRecord('74a7508b', component.options)
    } else {
      api.reload('74a7508b', component.options)
    }
    module.hot.accept("./CoTwoFilmVehicleForm.vue?vue&type=template&id=74a7508b&scoped=true&", function () {
      api.rerender('74a7508b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoFilmVehicleForm.vue"
export default component.exports